var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8252 0.160476C7.54775 0.249014 0.0720307 7.86879 0.160569 17.1463C0.249107 26.4237 7.86889 33.8995 17.1464 33.8109C26.4238 33.7224 33.8996 26.1026 33.811 16.8251C33.7225 7.54766 26.1027 0.071938 16.8252 0.160476ZM17.128 31.8859C8.91194 31.9643 2.16399 25.3438 2.08558 17.1279C2.00717 8.91196 8.62755 2.16389 16.8436 2.08549C25.0596 2.00708 31.8076 8.62756 31.886 16.8435C31.9644 25.0594 25.344 31.8075 17.128 31.8859Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7958 7.81829L18.5142 7.84007C16.6468 7.85789 15.1421 9.39164 15.1599 11.259L15.1844 13.8257L13.0589 13.846C12.5272 13.851 12.1005 14.286 12.1056 14.8177C12.1106 15.3493 12.5456 15.7761 13.0772 15.771L15.2028 15.7507L15.2878 24.6627C15.2929 25.1944 15.7279 25.6211 16.2595 25.6161C16.7911 25.611 17.2179 25.176 17.2128 24.6444L17.1278 15.7323L20.4163 15.7009C20.948 15.6959 21.3747 15.2609 21.3697 14.7293C21.3646 14.1976 20.9296 13.7709 20.398 13.7759L17.1094 13.8073L17.0849 11.2406C17.0772 10.4347 17.7266 9.77277 18.5326 9.76507L20.814 9.7433C21.3457 9.73823 21.7724 9.30323 21.7674 8.77161C21.7623 8.23999 21.3273 7.81322 20.7958 7.81829Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.652,
    height: 33.652,
    fill: "white",
    transform: "translate(0 0.321045) rotate(-0.546776)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.bc532f6eceeb7b7f36c403b33f360aa9.svg";
export { ForwardRef as ReactComponent };